import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ApiService } from "../../../services/api.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormHelper } from "../../../helpers/form.helper";
import { IonicHelper } from "../../../helpers/ionic.helper";
import { Category } from '../../../app/app.interfaces';

@Component({
	selector: 'admin-category-create',
	templateUrl: 'admin-category-create.html'
})


export class AdminCategoryCreate implements OnInit {

	form: FormGroup;
	edit: boolean = false;
	@Output() categoryCreated: EventEmitter<Category> = new EventEmitter<Category>();

	constructor( private apiService: ApiService,
							 private ionic: IonicHelper,
							 private formBuilder: FormBuilder){
	}

	ngOnInit(): void {
		this.buildForm();
	}

	buildForm(): void {
		this.form = this.formBuilder.group({
			title: ['', Validators.compose([Validators.minLength(5), Validators.maxLength(100)])]
		});
	}
	
	toggleEdit(show) {
		if(show===undefined) this.edit = !this.edit;
		else this.edit = show;
	}

	submitForm(): void {

		this.ionic.toggleLoader(true);

		if (this.form.valid) {

			let newCategory = FormHelper.createObjectFromFormValues(this.form);

			this.apiService.createResource('categories', newCategory).then((category) => {

				this.form.reset();
				this.ionic.toggleLoader(false);

				this.ionic.toast('ADMIN.CATEGORIES.CREATED_TOAST');
				this.edit = false;
				
				this.categoryCreated.emit(category);


			}).catch((err) => {
				console.error(err);
				this.ionic.toggleLoader(false);
				if (err.data['hydra:description'].indexOf('This value is already used') > 0) {
          this.ionic.alert('GLOBAL.ERRORS.CATEGORY_ALREADY_EXISTS');
        } else if (err.data['hydra:description'].indexOf('This value is too short') > 0) {
				  this.ionic.alert('GLOBAL.ERRORS.CATEGORY_TOO_SHORT');
        } else {
          this.ionic.alert('GLOBAL.GENERAL_ERROR');
        }
			});
		}
		else {
			this.ionic.toggleLoader(false);
			this.ionic.invalidFieldsAlert(
				'ADMIN.CATEGORIES.ERROR',
				'POST_CREATE.TRY_AGAIN',
				'ADMIN.CATEGORIES.ERRORS',
				FormHelper.getInvalidFormControls(this.form.controls)
			);
		}

	}

}



// WEBPACK FOOTER //
// ./src/partials/admin/admin-category-create/admin-category-create.ts